/* eslint-disable react/no-multi-comp */
import React from 'react';

export const CostReasonIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="48" height="48" fill="#F28C8D" rx="4" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M7.74 14c-.437 0-.74.386-.74.74v17a.77.77 0 0 0 .74.75.77.77 0 0 0 .738-.75V15.477h30.305a.77.77 0 0 0 .75-.739.77.77 0 0 0-.75-.739H7.739zm2.956 2.957c-.426 0-.73.406-.74.739v16.26c0 .388.353.74.74.74H40.26c.387 0 .739-.352.739-.74v-16.26a.768.768 0 0 0-.74-.74H10.697zm.739 1.478h8.373c-1.962 1.77-3.2 4.434-3.2 7.391 0 2.963 1.243 5.624 3.211 7.391h-8.384V18.435zm10.948 0h6.19c2.513 1.278 4.297 4.096 4.297 7.391 0 3.306-1.795 6.12-4.32 7.391h-6.144c-2.525-1.272-4.319-4.085-4.319-7.39 0-3.296 1.783-6.114 4.296-7.392zm8.766 0h8.373v14.782h-8.385c1.969-1.767 3.21-4.428 3.21-7.39 0-2.958-1.237-5.621-3.198-7.392zm-5.67 1.109a.74.74 0 0 0-.74.739v.462a2.928 2.928 0 0 0-2.217 2.864c0 .926.45 1.65 1.005 2.055.406.297.82.47 1.212.636v3.014a2.12 2.12 0 0 1-.82-.866c-.148-.383-.65-.576-1.016-.393-.367.183-.517.703-.3 1.051.383.767 1.124 1.54 2.136 1.802v.462a.74.74 0 1 0 1.478 0v-.462a2.928 2.928 0 0 0 2.218-2.864c0-.927-.45-1.663-1.005-2.068-.406-.296-.82-.47-1.213-.635v-3.003c.362.203.655.525.82.855.149.382.65.576 1.017.393.366-.184.517-.703.3-1.051-.383-.767-1.125-1.531-2.137-1.79v-.462a.74.74 0 0 0-.739-.74zm-.74 2.737v2.39c-.532-.236-.736-.587-.739-1.062 0-.68.276-1.117.74-1.328zm1.478 4.688c.534.236.748.619.74 1.074 0 .68-.276 1.117-.74 1.328v-2.402z"
      />
    </g>
  </svg>
);

export const CalculatorIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="44.5px"
    height="50px"
    viewBox="0 0 44.5 50"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M5.3,25.5h5.3v-5.3H5.3V25.5z M6.4,21.3h3.2v3.2H6.4V21.3z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M5.3,35.1h5.3v-5.3H5.3V35.1z M6.4,34v-3.2h3.2V34L6.4,34L6.4,34z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M5.3,44.7h5.3v-5.3H5.3V44.7z M6.4,40.4h3.2v3.2H6.4V40.4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M24.5,44.7h5.3v-5.3h-5.3V44.7z M25.5,40.4h3.2v3.2h-3.2V40.4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M24.5,35.1h5.3v-5.3h-5.3V35.1z M25.5,34v-3.2h3.2V34L25.5,34L25.5,34z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M14.9,44.7L14.9,44.7h5.3v-5.3h-5.3V44.7z M16,40.4h3.2v3.2H16C16,43.6,16,40.4,16,40.4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M14.9,35.1L14.9,35.1l5.3,0v-5.3h-5.3V35.1z M16,34v-3.2h3.2V34L16,34L16,34z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M14.9,25.5L14.9,25.5h5.3v-5.3h-5.3V25.5z M16,21.3h3.2v3.2H16C16,24.5,16,21.3,16,21.3z"
      />
      <polygon
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        points="5.3,16 5.3,16 5.3,16 	"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M44.5,17c0-5.2-4.2-9.4-9.4-9.5V2.7c0-1.5-1.2-2.7-2.7-2.7H2.7C1.2,0,0,1.2,0,2.7v44.7C0,48.8,1.2,50,2.7,50
		h29.8c1.5,0,2.7-1.2,2.7-2.7V26.5C40.3,26.4,44.5,22.2,44.5,17z M32.4,48.9H2.7c-0.9,0-1.6-0.7-1.6-1.6V2.7c0-0.9,0.7-1.6,1.6-1.6
		h29.8c0.9,0,1.6,0.7,1.6,1.6v4.9c-1.6,0.2-3,0.7-4.3,1.5V5.3H5.3V16h20.2c0,0.3-0.1,0.7-0.1,1c0,1.1,0.2,2.2,0.6,3.2h-1.6v5.3h5.3
		v-0.6c1.2,0.8,2.7,1.4,4.3,1.5v20.9C34,48.2,33.3,48.9,32.4,48.9z M28.7,24.1v0.4h-3.2v-3.2h1C27.1,22.4,27.8,23.3,28.7,24.1z
		 M25.7,14.9H6.4v0V6.4h22.3v3.5C27.3,11.2,26.2,12.9,25.7,14.9z M35,25.5c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5
		S39.7,25.5,35,25.5z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#85736B"
        d="M37.7,18.3c-0.2-0.3-0.4-0.5-0.8-0.7c-0.3-0.2-0.9-0.4-1.6-0.6v-2.9c0.7,0.1,1.4,0.2,2,0.5l0.3-0.9
		c-0.7-0.3-1.5-0.5-2.4-0.5V12h-0.9v1.2c-0.7,0.1-1.3,0.3-1.8,0.7c-0.4,0.4-0.7,0.8-0.7,1.4c0,0.6,0.2,1.1,0.5,1.5
		c0.4,0.4,1,0.7,1.9,1v2.9c-0.4,0-0.8-0.1-1.3-0.2c-0.5-0.1-0.9-0.2-1.3-0.4v1c0.3,0.1,0.7,0.2,1.1,0.3c0.5,0.1,0.9,0.1,1.4,0.1v1.5
		h0.9v-1.5c0.8-0.1,1.4-0.3,1.9-0.7c0.4-0.4,0.7-0.9,0.7-1.5h0C38,18.9,37.9,18.6,37.7,18.3z M34.6,16.7c-0.5-0.2-0.8-0.4-1-0.6
		c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.6-0.3,1-0.4V16.7z M35.4,20.6V18c0.6,0.2,0.9,0.4,1.1,0.6
		c0.2,0.2,0.3,0.5,0.3,0.8C36.9,20.1,36.4,20.5,35.4,20.6z"
      />
    </g>
  </svg>
);

export const CandleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="49"
    viewBox="0 0 34 49"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#85736B"
        d="M27.571 42.29H6.31l-3.577-3.575h28.415l-3.576 3.576zm-.446 4.211c0 .42-.34.761-.76.761H7.515a.762.762 0 0 1-.761-.76v-2.69h20.371v2.69zM10.054 13.74c0-.419.342-.76.762-.76h12.249c.42 0 .76.341.76.76v23.456H10.054V13.739zm4.324-8.186c0-1.338 1.581-2.904 2.562-3.702.981.796 2.561 2.36 2.561 3.702 0 1.763-1.03 2.948-2.56 2.948-1.533 0-2.563-1.185-2.563-2.948zm19.308 32.11a.76.76 0 0 0-.702-.468h-7.637V13.739a2.284 2.284 0 0 0-2.282-2.28H17.7V9.945c1.962-.358 3.321-2.092 3.321-4.393 0-2.627-3.27-5.015-3.642-5.279a.764.764 0 0 0-.878 0c-.373.264-3.643 2.652-3.643 5.279 0 2.301 1.36 4.035 3.321 4.393v1.512h-5.363a2.283 2.283 0 0 0-2.282 2.281v23.456H.896a.76.76 0 0 0-.538 1.296l4.876 4.875v3.135a2.284 2.284 0 0 0 2.28 2.283h18.85a2.285 2.285 0 0 0 2.283-2.283v-3.135l4.874-4.875a.76.76 0 0 0 .165-.829z"
      />
      <path
        stroke="#FFF"
        strokeWidth=".2"
        d="M27.571 42.29H6.31l-3.577-3.575h28.415l-3.576 3.576zm-.446 4.211c0 .42-.34.761-.76.761H7.515a.762.762 0 0 1-.761-.76v-2.69h20.371v2.69zM10.054 13.74c0-.419.342-.76.762-.76h12.249c.42 0 .76.341.76.76v23.456H10.054V13.739zm4.324-8.186c0-1.338 1.581-2.904 2.562-3.702.981.796 2.561 2.36 2.561 3.702 0 1.763-1.03 2.948-2.56 2.948-1.533 0-2.563-1.185-2.563-2.948zm19.308 32.11a.76.76 0 0 0-.702-.468h-7.637V13.739a2.284 2.284 0 0 0-2.282-2.28H17.7V9.945c1.962-.358 3.321-2.092 3.321-4.393 0-2.627-3.27-5.015-3.642-5.279a.764.764 0 0 0-.878 0c-.373.264-3.643 2.652-3.643 5.279 0 2.301 1.36 4.035 3.321 4.393v1.512h-5.363a2.283 2.283 0 0 0-2.282 2.281v23.456H.896a.76.76 0 0 0-.538 1.296l4.876 4.875v3.135a2.284 2.284 0 0 0 2.28 2.283h18.85a2.285 2.285 0 0 0 2.283-2.283v-3.135l4.874-4.875a.76.76 0 0 0 .165-.829z"
      />
    </g>
  </svg>
);

export const ChecklistIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="50"
    viewBox="0 0 37 50"
  >
    <path
      fill="#85736B"
      fillRule="nonzero"
      stroke="#85736B"
      strokeWidth=".2"
      d="M3.717.543A2.723 2.723 0 0 0 1 3.261v43.478a2.723 2.723 0 0 0 2.717 2.718h30.435a2.723 2.723 0 0 0 2.718-2.718V3.261A2.723 2.723 0 0 0 34.152.543H3.717zm0 1.087h30.435c.913 0 1.63.718 1.63 1.63v43.48c0 .912-.717 1.63-1.63 1.63H3.717c-.912 0-1.63-.718-1.63-1.63V3.26c0-.912.718-1.63 1.63-1.63zm2.174 4.892c-.345.005-.545.32-.543.543v7.609c0 .284.259.543.543.543h9.783a.565.565 0 0 0 .543-.543V7.065a.565.565 0 0 0-.543-.543H5.89zm.544 1.087h8.695v6.521H6.435V7.61zm13.587 2.717a.543.543 0 1 0 0 1.087h11.956a.543.543 0 1 0 0-1.087H20.022zm-2.225 8.135a.552.552 0 0 0-.39.238l-4.586 6.624L10 23.455a.565.565 0 0 0-.758.142.565.565 0 0 0 .147.758l3.26 2.174a.564.564 0 0 0 .748-.136l4.891-7.066c.252-.336-.074-.91-.492-.866zM5.89 19.565a.552.552 0 0 0-.543.544v9.782c0 .285.259.544.543.544h9.783a.565.565 0 0 0 .543-.544v-1.087a.557.557 0 0 0-.543-.543.558.558 0 0 0-.544.543v.544H6.435v-8.696h5.978a.557.557 0 0 0 .544-.543.558.558 0 0 0-.544-.544H5.891zm14.13 4.892a.544.544 0 0 0 0 1.086h11.957a.543.543 0 1 0 0-1.086H20.022zM5.892 34.783c-.345.005-.545.32-.543.543v7.609c0 .284.259.543.543.543h9.783a.565.565 0 0 0 .543-.543v-7.609a.565.565 0 0 0-.543-.543H5.89zm.544 1.087h8.695v6.521H6.435V35.87zm13.587 2.717a.543.543 0 1 0 0 1.087h11.956a.543.543 0 1 0 0-1.087H20.022z"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="53.7px"
    height="50px"
    viewBox="0 0 53.7 50"
  >
    <g>
      <path
        fill="#85736B"
        d="M47.5,0L47.5,0l-0.4,0c0,0-0.1,0-0.1,0H13.8c-3.4,0-6.2,2.7-6.2,6.2v31.4H5.8c0,0-0.1,0-0.1,0
		c-3.4,0.3-6,3.3-5.7,6.7c0.3,3,2.6,5.4,5.7,5.7c0,0,0.1,0,0.1,0h30.6c3.4,0,6.2-2.8,6.2-6.2V12.5h4.9c3.4,0,6.2-2.8,6.2-6.2
		C53.7,2.8,50.9,0,47.5,0z M6.2,48.7L6.2,48.7c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9h26.3c-2.7,2.1-3.2,6-1,8.7
		c0.3,0.4,0.6,0.7,1,1H6.2z M41.3,6.2v37.7h0c0,2.7-2.2,4.9-4.9,4.9c0,0,0,0,0,0c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9
		c0,0,0,0,0,0c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7H8.9V6.2c0-2.7,2.2-4.9,4.9-4.9h29.8C42.2,2.5,41.3,4.3,41.3,6.2z M47.5,11.1
		L47.5,11.1l-4.9,0V6.2c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9S50.2,11.1,47.5,11.1z"
      />
      <rect x="14.4" y="24" fill="#85736B" width="21.1" height="1.4" />
      <rect x="14.4" y="29.2" fill="#85736B" width="21.1" height="1.4" />
      <rect x="14.4" y="11.6" fill="#85736B" width="4.4" height="1.4" />
      <rect x="14.4" y="18.8" fill="#85736B" width="21.1" height="1.4" />
      <rect x="21" y="11.6" fill="#85736B" width="14.5" height="1.4" />
    </g>
  </svg>
);

export const GravestoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="50"
    viewBox="0 0 36 50"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#85736B"
        d="M32.98 46.948H2.376v-1.321c0-.465.727-.987 1.701-.987H31.28c.975 0 1.7.52 1.7.987v1.321zM5.7 38.475a1.04 1.04 0 0 1 1.036-1.036H28.62a1.04 1.04 0 0 1 1.038 1.036V42.6H5.7v-4.125zm5.242-29.534l6.736-6.197 6.735 6.197V35.4H10.942V8.94zm20.755 33.695v-4.16A3.08 3.08 0 0 0 28.62 35.4h-2.166V8.493c0-.284-.12-.557-.329-.752L18.37.606a1.02 1.02 0 0 0-1.381 0L9.232 7.741a1.03 1.03 0 0 0-.328.752V35.4H6.736a3.08 3.08 0 0 0-3.075 3.075v4.161c-1.891.165-3.323 1.412-3.323 2.99v2.341a1.02 1.02 0 0 0 1.02 1.02h32.64a1.02 1.02 0 0 0 1.02-1.02v-2.34c0-1.579-1.432-2.826-3.321-2.99z"
      />
      <path
        stroke="#FFF"
        strokeWidth=".5"
        d="M32.98 46.948H2.376v-1.321c0-.465.727-.987 1.701-.987H31.28c.975 0 1.7.52 1.7.987v1.321zM5.7 38.475a1.04 1.04 0 0 1 1.036-1.036H28.62a1.04 1.04 0 0 1 1.038 1.036V42.6H5.7v-4.125zm5.242-29.534l6.736-6.197 6.735 6.197V35.4H10.942V8.94zm20.755 33.695v-4.16A3.08 3.08 0 0 0 28.62 35.4h-2.166V8.493c0-.284-.12-.557-.329-.752L18.37.606a1.02 1.02 0 0 0-1.381 0L9.232 7.741a1.03 1.03 0 0 0-.328.752V35.4H6.736a3.08 3.08 0 0 0-3.075 3.075v4.161c-1.891.165-3.323 1.412-3.323 2.99v2.341a1.02 1.02 0 0 0 1.02 1.02h32.64a1.02 1.02 0 0 0 1.02-1.02v-2.34c0-1.579-1.432-2.826-3.321-2.99z"
      />
    </g>
  </svg>
);

export const TreeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="49"
    viewBox="0 0 36 49"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#85736B"
        d="M8.465 12.65c2.089 1.674 2.757 4.681 2.925 6.103-1.422.166-4.513.25-6.604-1.422-2.087-1.671-2.757-4.68-2.923-6.1 1.42-.084 4.512-.252 6.602 1.42m6.016-4.347c0-2.673 2.007-5.012 3.009-6.016 1.003 1.004 3.009 3.343 2.925 6.016 0 2.675-2.006 5.017-3.01 6.02-.917-1.003-2.924-3.345-2.924-6.02m12.285 4.347c2.09-1.672 5.18-1.504 6.602-1.42-.168 1.42-.836 4.429-2.925 6.1-2.09 1.672-5.182 1.504-6.602 1.422.25-1.422.836-4.429 2.925-6.102M24.76 25.353c2.09-1.67 5.182-1.504 6.604-1.42-.168 1.42-.838 4.43-2.925 6.1-2.09 1.671-5.182 1.505-6.602 1.421.166-1.421.752-4.428 2.923-6.101m-18.218 4.68c-2.089-1.67-2.757-4.68-2.923-6.1 1.42-.166 4.513-.25 6.6 1.42 2.09 1.673 2.76 4.68 2.927 6.101-1.338.084-4.43.25-6.604-1.421m-2.84-11.364c1.923 1.503 4.346 1.837 6.183 1.837.92 0 1.672-.082 2.09-.166l4.68 4.26v8.776L14.9 31.704c-.084-1.251-.67-5.43-3.594-7.687-3.427-2.675-8.525-1.671-8.691-1.588-.418.083-.668.418-.668.834 0 .252.25 5.433 3.593 8.108 1.921 1.503 4.344 1.839 6.184 1.839.92 0 1.671-.084 2.089-.168l2.84 2.675v12.004c0 .501.335.926.837.926.501 0 .835-.453.835-.953V35.8l2.841-2.759c.418.084 1.172.168 2.09.168 1.839 0 4.262-.336 6.184-1.84 3.426-2.674 3.594-7.855 3.594-8.107 0-.416-.252-.751-.67-.834-.25-.083-5.348-1.087-8.69 1.588-2.925 2.34-3.51 6.52-3.593 7.687l-1.756 1.672V24.6l4.93-4.26c.419.083 1.17.165 2.09.165 1.84 0 4.263-.334 6.186-1.837 3.425-2.675 3.593-7.856 3.593-8.107 0-.416-.252-.752-.67-.836-.25-.084-5.348-1.086-8.691 1.587-2.925 2.258-3.51 6.434-3.593 7.69l-3.845 3.343v-6.604c1.002-.918 3.845-3.843 3.845-7.52 0-4.346-3.929-7.687-4.095-7.855a.877.877 0 0 0-1.087 0c-.166.168-4.095 3.509-4.095 7.855 0 3.677 2.925 6.77 3.845 7.604v6.52l-3.593-3.26c-.084-1.255-.67-5.432-3.595-7.689C6.124 8.724 1.025 9.726.86 9.81c-.419.084-.669.418-.669.836-.084.167.166 5.348 3.51 8.023"
      />
      <path
        stroke="#FFF"
        strokeWidth=".2"
        d="M8.465 12.65c2.089 1.674 2.757 4.681 2.925 6.103-1.422.166-4.513.25-6.604-1.422-2.087-1.671-2.757-4.68-2.923-6.1 1.42-.084 4.512-.252 6.602 1.42zm6.016-4.346c0-2.673 2.007-5.012 3.009-6.016 1.003 1.004 3.009 3.343 2.925 6.016 0 2.675-2.006 5.017-3.01 6.02-.917-1.003-2.924-3.345-2.924-6.02zm12.285 4.347c2.09-1.672 5.18-1.504 6.602-1.42-.168 1.42-.836 4.429-2.925 6.1-2.09 1.672-5.182 1.504-6.602 1.422.25-1.422.836-4.429 2.925-6.102zM24.76 25.353c2.09-1.67 5.182-1.504 6.604-1.42-.168 1.42-.838 4.43-2.925 6.1-2.09 1.671-5.182 1.505-6.602 1.421.166-1.421.752-4.428 2.923-6.101zm-18.218 4.68c-2.089-1.67-2.757-4.68-2.923-6.1 1.42-.166 4.513-.25 6.6 1.42 2.09 1.673 2.76 4.68 2.927 6.101-1.338.084-4.43.25-6.604-1.421zm-2.84-11.364c1.923 1.503 4.346 1.837 6.183 1.837.92 0 1.672-.082 2.09-.166l4.68 4.26v8.776L14.9 31.704c-.084-1.251-.67-5.43-3.594-7.687-3.427-2.675-8.525-1.671-8.691-1.588-.418.083-.668.418-.668.834 0 .252.25 5.433 3.593 8.108 1.921 1.503 4.344 1.839 6.184 1.839.92 0 1.671-.084 2.089-.168l2.84 2.675v12.004c0 .501.335.926.837.926.501 0 .835-.453.835-.953V35.8l2.841-2.759c.418.084 1.172.168 2.09.168 1.839 0 4.262-.336 6.184-1.84 3.426-2.674 3.594-7.855 3.594-8.107 0-.416-.252-.751-.67-.834-.25-.083-5.348-1.087-8.69 1.588-2.925 2.34-3.51 6.52-3.593 7.687l-1.756 1.672V24.6l4.93-4.26c.419.083 1.17.165 2.09.165 1.84 0 4.263-.334 6.186-1.837 3.425-2.675 3.593-7.856 3.593-8.107 0-.416-.252-.752-.67-.836-.25-.084-5.348-1.086-8.691 1.587-2.925 2.258-3.51 6.434-3.593 7.69l-3.845 3.343v-6.604c1.002-.918 3.845-3.843 3.845-7.52 0-4.346-3.929-7.687-4.095-7.855a.877.877 0 0 0-1.087 0c-.166.168-4.095 3.509-4.095 7.855 0 3.677 2.925 6.77 3.845 7.604v6.52l-3.593-3.26c-.084-1.255-.67-5.432-3.595-7.689C6.124 8.724 1.025 9.726.86 9.81c-.419.084-.669.418-.669.836-.084.167.166 5.348 3.51 8.023z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/WhatsIncluded/Svgs.js